import apiClient from './apiClient';
import { User, LoginRequest as LoginCredentials, RegisterRequest as RegisterCredentials } from '../types/auth.types';

export const login = async (username: string, password: string) => {
  const formData = new URLSearchParams();
  formData.append('username', username);
  formData.append('password', password);
  
  try {
    const response = await apiClient.post('/auth/token', formData.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 401) {
      throw new Error('Invalid username or password. Please try again.');
    }
    throw error;
  }
};

export const register = async (userData: any) => {
  const response = await apiClient.post('/auth/register', userData);
  return response.data;
};

export const confirmEmail = async (token: string) => {
  const response = await apiClient.post(`/auth/confirm-email/${token}`);
  return response.data;
};

export const resendConfirmation = async (email: string) => {
  const response = await apiClient.post('/auth/resend-confirmation', { email });
  return response.data;
};

export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};

export const logout = async () => {
  return await apiClient.post('/auth/logout');
};

export const loginUser = login; 